module.exports = __webpack_public_path__ + "static/media/5.26b10a26.jpg";